<app-workspace-window-title i18n-windowTitle windowTitle="Workspaces" />

<app-workspace-page-content
  [title]="title()"
  variant="tertiary"
  [showClose]="false"
  [bodyPadding]="0"
  [style.--overflow-actions-min-width]="'90px'"
>
  <ng-template #headerActions>
    <standard-button
      variant="secondary-link"
      styleClass="btn-header-actions"
      [icon]="faSearch"
      [standardTooltip]="isSearchVisible() ? hideSearchText : showSearchText"
      (handleClick)="toggleSearch()"
      (mouseenter)="searchIconHovered.set(true)"
    />
    <standard-button-dropdown-actions
      variant="secondary-link"
      styleClass="btn-header-actions"
      [items]="
        isSearchVisible() ? searchActionMenuItems() : listActionMenuItems()
      "
    />
    <standard-button
      styleClass="btn-header-actions"
      variant="secondary-link"
      [icon]="faXmark"
      i18n-standardTooltip
      standardTooltip="Close"
      (handleClick)="modalPage.close()"
    />
  </ng-template>

  @if (!isSearchVisible()) {
    <ng-template #subTitle>
      <standard-field-wrapper labelInline="before" i18n-label label="Filter:">
        <standard-button-dropdown
          variant="secondary-link"
          [items]="filterMenuItems() | annotateActiveCode: activeFilterCode()"
        >
          {{ activeFilterLabel() }}
        </standard-button-dropdown>
      </standard-field-wrapper>

      <standard-field-wrapper labelInline="before" i18n-label label="Sort:">
        <standard-button-dropdown
          variant="secondary-link"
          [items]="sortMenuItems | annotateActiveCode: activeSortCode()"
        >
          {{ activeSortLabel() }}
        </standard-button-dropdown>
      </standard-field-wrapper>

      <standard-field-wrapper labelInline="before" i18n-label label="Group:">
        <standard-button-dropdown
          variant="secondary-link"
          [items]="groupMenuItems | annotateActiveCode: activeGroupCode()"
        >
          {{ activeGroupLabel() }}
        </standard-button-dropdown>
      </standard-field-wrapper>
    </ng-template>
  }

  @defer (when searchIconHovered(); prefetch on idle) {
    @if (isSearchVisible()) {
      <form [formGroup]="searchForm" class="pt-2 px-3">
        @if (isSupportUser()) {
          <standard-field-wrapper
            i18n-label
            label="Member firm"
            [required]="isSupportUser()"
          >
            <standard-dropdown-single
              formControlName="selectedMemberFirmId"
              [options]="onboardedFirms"
            />
          </standard-field-wrapper>
        }
        <standard-field-wrapper i18n-label label="Client ID">
          <standard-text-input
            formControlName="clientId"
            [autoFocus]="true"
            [maxlength]="200"
          />
        </standard-field-wrapper>

        <standard-field-wrapper i18n-label label="Client name">
          <standard-text-input formControlName="clientName" [maxlength]="200" />
        </standard-field-wrapper>

        <standard-field-wrapper i18n-label label="Entity name">
          <standard-text-input formControlName="entityName" [maxlength]="200" />
        </standard-field-wrapper>

        <standard-field-wrapper
          i18n-label
          label="Display name of the workspace"
        >
          <standard-text-input
            formControlName="workspaceDisplayName"
            [maxlength]="200"
          />
        </standard-field-wrapper>

        @if (canViewEngagementSnapshots()) {
          <standard-field-wrapper i18n-label label="Engagement ID">
            <standard-text-input formControlName="engagementId" />
          </standard-field-wrapper>
        }

        <standard-button
          type="submit"
          variant="primary"
          (handleClick)="performSearch()"
          [disabled]="
            (!(f.clientId.value?.trim() ?? '') &&
              !(f.clientName.value?.trim() ?? '') &&
              !(f.entityName.value?.trim() ?? '') &&
              !(f.workspaceDisplayName.value?.trim() ?? '') &&
              !(f.engagementId.value?.trim() ?? '')) ||
            !searchForm.valid
          "
          i18n
          >Search</standard-button
        >
      </form>
    }
  } @placeholder {
    <div></div>
  }

  @if (!isSearchVisible()) {
    <standard-query-error
      class="mx-3"
      i18n-title
      title="Failed to load workspaces"
      [error]="engagementsTableService.error()"
      [showRefresh]="true"
      (refresh)="engagementsTableService.refresh()"
    />
    <app-workspace-list-tree
      #favoritesTree
      class="favorites-tree"
      [class.d-none]="!favoriteWorkspaces().length"
      height="auto"
      [stickyParentNodes]="false"
      [activeFilterCode]="activeFilterCode()"
      [activeGroupCode]="activeGroupCode()"
      [transitionState]="engagementsTableService.transitionState()"
      [loading]="false"
      [tree]="favoriteWorkspaces()"
      [aptVersion]="aptVersion()"
      [isSupportUser]="isSupportUser()"
      [workspaceListContentWrapper]="host.nativeElement"
      (onSelectionUpdated)="onSelectionUpdated('fav', $event)"
      (navToWorkspace)="
        workspaceListService.navToWorkspace(
          $event,
          loading,
          modalPage,
          isSupportUser()
        )
      "
      (refreshEngagements)="handleRefreshWithBCMessage()"
    />
    <app-workspace-list-tree
      #groupsTree
      [activeFilterCode]="activeFilterCode()"
      [activeGroupCode]="activeGroupCode()"
      [transitionState]="engagementsTableService.transitionState()"
      [loading]="engagementsTableService.loading() || loading()"
      [tree]="groupedWorkspaces()"
      [aptVersion]="aptVersion()"
      [isSupportUser]="isSupportUser()"
      [workspaceListContentWrapper]="host.nativeElement"
      (onSelectionUpdated)="onSelectionUpdated('group', $event)"
      (navToWorkspace)="
        workspaceListService.navToWorkspace(
          $event,
          loading,
          modalPage,
          isSupportUser()
        )
      "
      (refreshEngagements)="handleRefreshWithBCMessage()"
    />
  }
</app-workspace-page-content>
@if (workspaceListService.isViewingCloneCopyRollforward()) {
  <!-- adjust z-index to show above sticky ws tree items-->
  <div
    class="p-dialog-mask p-component-overlay position-absolute"
    [style.z-index]="11"
  ></div>
}
